export default "__VITE_ASSET__Dju4Jok1__"